import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { EnvironmentService } from '../../../../core/environment/environment.service';
import { PackageWorkflowVersion, WorkflowName, WorkflowStateUiMappings } from '../../models/workflows';

@Injectable({
  providedIn: 'root'
})
export class WorkflowEngineService {
  private http = inject(HttpClient);
  private envService = inject(EnvironmentService);

  get workflowEngineApiUrl(): string {
    return `${this.envService.apiUrls.workflowEngine}/v1`;
  }

  public loadWorkflowUiMappings(workflowName: WorkflowName, version?: PackageWorkflowVersion): Observable<WorkflowStateUiMappings> {
    const url = `${this.workflowEngineApiUrl}/ui-mappings/${workflowName}`;
    if (workflowName === 'damage_package_workflow') {
      if (version !== 'v6' && version !== 'v10') return throwError(() => new Error('Package workflow version is required'));
      return this.http.get<WorkflowStateUiMappings>(url, { params: { workflow_version: version } });
    }
    return this.http.get<WorkflowStateUiMappings>(url);
  }
}
